module.exports = __webpack_public_path__ + "static/media/wifi-1.74f6c43f.svg";